var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBandintown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9629 2.01782H17.126V12.2741H20.9629V2.01782Z",
    fill: "#00CEC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8349 7.40381H11.998V12.2742H15.8349V7.40381Z",
    fill: "#00CEC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9673 7.40381H7.13037V12.2742H10.9673V7.40381Z",
    fill: "#00CEC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25977 2.01782V22.0122H16.8315H17.1261H20.9998V13.6389H7.24062V17.2891H17.1261V18.3594H6.13347V2.01782H2.25977Z",
    fill: "#00CEC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandintown);
export default __webpack_public_path__ + "static/media/bandintown.7f167741.svg";
export { ForwardRef as ReactComponent };